<div class="page-header card">
    <div class="row align-items-end">
        <div class="col-lg-7">
            <div class="page-header-title">
                <a href="javascript:void(0);" (click)="backClicked()"><i class="feather icon-arrow-left  bg-c-blue"></i></a>
                <div class="d-inline">
                    <h5>Credit Union</h5>
                    <span>This page permit the user to create a Credit Union</span>
                </div>
            </div>
        </div>
        <div class="col-lg-5">
            <button (click)="initView()" class="btn waves-effect waves-light btn-info float-right"><i class="ti-reload"></i>Reload</button>

        </div>
    </div>
</div>

<div class="pcoded-inner-content">
    <div class="main-body">
        <div class="page-wrapper">
            <div class="page-body">

                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">

                        <div class="card">
                            <div class="card-header">
                                <h5>New Credit Union</h5>
                                <span>Add class of <code>.form-control</code> with <code>&lt;input&gt;</code> tag</span>
                            </div>
                            <div class="card-block">
                                <form #creForm="ngForm">
                                    <div class="form-group row">
                                      <label class="col-sm-3 col-form-label">Credit Union Type</label>
                                      <div class="col-sm-9">
                                          <select [(ngModel)]="cre.type" name="type" class="form-control" required>
                                              <option value="">Select a value</option>
                                              <option value="INTERNAL">Internal (CAMCCUL)</option>
                                              <option value="EXTERNAL_SYNC">External with data synchronization</option>
                                              <option value="EXTERNAL_UNSYNC">External without data synchronization</option>
                                          </select>
                                      </div>
                                    </div>
                                    <div class="form-group row" *ngIf="cre.type === 'INTERNAL'">
                                        <label class="col-sm-3 col-form-label">Select a Chapter</label>
                                        <div class="col-sm-9">
                                            <select [(ngModel)]="cre.chapterId" name="chapterId" class="form-control" required>

                                                <option value="">Select a value</option>
                                                <option *ngFor="let c of chaps" [value]="c.id">{{c.name}}</option>
                                                </select>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-sm-3 col-form-label">Name</label>
                                        <div class="col-sm-9">
                                            <input type="text" [(ngModel)]="cre.name" name="name" required class="form-control">
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-sm-3 col-form-label">Abreviation</label>
                                        <div class="col-sm-9">
                                            <input type="text" [(ngModel)]="cre.abrv" name="abrv" required class="form-control">
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-sm-3 col-form-label">Code</label>
                                        <div class="col-sm-9">
                                            <input type="text" [(ngModel)]="cre.code" name="code" required class="form-control">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="form-group row">
                                                <label class="col-sm-3 col-form-label">Phone 1</label>
                                                <div class="col-sm-3"></div>
                                                <div class="col-sm-6">
                                                    <input type="text" [(ngModel)]="cre.tel" name="tel" required class="form-control">
                                                    <span>Head office phone number</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group row">

                                                <div class="col-sm-2"></div>
                                                <label class="col-sm-3 col-form-label">Phone 2</label>
                                                <div class="col-sm-7">
                                                    <input type="text" [(ngModel)]="cre.tel2" name="tel2" class="form-control">
                                                    <span>Chief Loan officer's phone number</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-3 col-form-label">P.O Box</label>
                                        <div class="col-sm-9">
                                            <input type="text" [(ngModel)]="cre.box" name="box" class="form-control">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="form-group row">
                                                <label class="col-sm-3 col-form-label">Email 1</label>
                                                <div class="col-sm-3"></div>
                                                <div class="col-sm-6">
                                                    <input type="text" [(ngModel)]="cre.email1" name="email1" class="form-control">
                                                    <span>Notifications on Loan Deliquencies will be sent to this email address.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group row">

                                                <div class="col-sm-2"></div>
                                                <label class="col-sm-3 col-form-label">Email 2</label>
                                                <div class="col-sm-7">
                                                    <input type="text" [(ngModel)]="cre.email2" name="email2" class="form-control">
                                                    <span>Notifications on Loan Deliquencies will be sent to this email address.</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="form-group row">
                                                <label class="col-sm-6 col-form-label">Head Office Location</label>
                                                <div class="col-sm-6">
                                                    <input type="text" [(ngModel)]="cre.headOffice" name="headOffice" required class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group row">

                                                <div class="col-sm-1"></div>
                                                <label class="col-sm-4 col-form-label">Billing Start Date</label>
                                                <div class="col-sm-7">
                                                    <input type="date" [(ngModel)]="cre.grEndDate" name="grEndDate" class="form-control">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row" *ngIf="cre.type !== 'INTERNAL'">
                                      <div class="col-sm-6">
                                          <div class="form-group row">
                                              <label class="col-sm-6 col-form-label">Fee Rate</label>
                                              <div class="col-sm-6">
                                                  <input type="number" [(ngModel)]="cre.feeAmount" name="feeAmount" required class="form-control" min="0" max="100">
                                              </div>
                                          </div>
                                      </div>
                                      <div class="col-sm-6">
                                          <div class="form-group row">

                                              <div class="col-sm-1"></div>
                                              <label class="col-sm-4 col-form-label">Loan Portfolio</label>
                                              <div class="col-sm-7">
                                                  <input type="number" [(ngModel)]="cre.loanPortfolioAmount" name="loanPortfolioAmount" class="form-control">
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                    <button class="btn btn-mat waves-effect waves-light btn-inverse   float-right" [disabled]="!creForm.form.valid" (click)="onCreate()">Validate</button>

                                </form>
                            </div>
                        </div>


                    </div>
                    <div class="col-sm-1"></div>
                </div>

            </div>
        </div>
    </div>
</div>
